module.exports = __webpack_public_path__ + "img/bg.73f6391f.jpg";